var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        { staticClass: "mb-4", attrs: { dense: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "2", md: "2" } },
            [
              _c("v-text-field", {
                attrs: { label: "Mana:", "hide-details": "" },
                model: {
                  value: _vm.value.mana,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "mana", _vm._n($$v))
                  },
                  expression: "value.mana",
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "2", md: "2" } },
            [
              _c("v-text-field", {
                attrs: { label: "Points:", "hide-details": "" },
                model: {
                  value: _vm.value.points,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "points", _vm._n($$v))
                  },
                  expression: "value.points",
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "2", md: "2" } },
            [
              _c("v-select", {
                attrs: {
                  items: _vm.shapeTypes,
                  "item-text": "name",
                  "item-value": "id",
                  label: "Shape type:",
                  "hide-details": "",
                },
                model: {
                  value: _vm.value.shape,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "shape", $$v)
                  },
                  expression: "value.shape",
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "3", md: "3" } },
            [
              _c("r-item-container-mode", {
                attrs: { model: _vm.value.container },
                on: {
                  "update:model": function ($event) {
                    return _vm.$set(_vm.value, "container", $event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "3", md: "3" } },
            [
              _c("r-item-collect-mode", {
                attrs: { model: _vm.value.collect },
                on: {
                  "update:model": function ($event) {
                    return _vm.$set(_vm.value, "collect", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4", md: "4" } },
            [
              !!_vm.value.rewardOnMerge
                ? _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", color: "success" },
                      on: { click: _vm.onRewardOnMerge },
                    },
                    [_vm._v("Merged on Merge ")]
                  )
                : _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", outlined: "", color: "primary" },
                      on: { click: _vm.onRewardOnMerge },
                    },
                    [_vm._v(" Merged on Merge ")]
                  ),
              !!_vm.value.rewardOnCreate
                ? _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", color: "success" },
                      on: { click: _vm.onRewardOnCreate },
                    },
                    [_vm._v("Reward On Create ")]
                  )
                : _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", outlined: "", color: "primary" },
                      on: { click: _vm.onRewardOnCreate },
                    },
                    [_vm._v(" Reward On Create ")]
                  ),
              !!_vm.value.rewardOnRemove
                ? _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", color: "success" },
                      on: { click: _vm.onRewardOnRemove },
                    },
                    [_vm._v("Reward On Remove ")]
                  )
                : _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", outlined: "", color: "primary" },
                      on: { click: _vm.onRewardOnRemove },
                    },
                    [_vm._v(" Reward On Remove ")]
                  ),
              !!_vm.value.rewardOnDelete
                ? _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", color: "success" },
                      on: { click: _vm.onRewardOnDelete },
                    },
                    [_vm._v("Reward On Delete ")]
                  )
                : _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", outlined: "", color: "primary" },
                      on: { click: _vm.onRewardOnDelete },
                    },
                    [_vm._v(" Reward On Delete ")]
                  ),
              !!_vm.value.rewardOnLevelUp
                ? _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", color: "success" },
                      on: { click: _vm.onRewardOnLevelUp },
                    },
                    [_vm._v("Reward On LevelUp ")]
                  )
                : _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", outlined: "", color: "primary" },
                      on: { click: _vm.onRewardOnLevelUp },
                    },
                    [_vm._v(" Reward On LevelUp ")]
                  ),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4", md: "4" } },
            [
              !!_vm.value.workerConfig
                ? _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", color: "success" },
                      on: { click: _vm.onWorkerConfig },
                    },
                    [_vm._v("Worker Config ")]
                  )
                : _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", outlined: "", color: "primary" },
                      on: { click: _vm.onWorkerConfig },
                    },
                    [_vm._v("Worker Config ")]
                  ),
              !!_vm.value.searchConfig
                ? _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", color: "success" },
                      on: { click: _vm.onSearchConfig },
                    },
                    [_vm._v("Search Config ")]
                  )
                : _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", outlined: "", color: "primary" },
                      on: { click: _vm.onSearchConfig },
                    },
                    [_vm._v("Search Config ")]
                  ),
              !!_vm.value.mergeConfig
                ? _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", color: "success" },
                      on: { click: _vm.onMergeConfig },
                    },
                    [_vm._v("Merge Config ")]
                  )
                : _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", outlined: "", color: "primary" },
                      on: { click: _vm.onMergeConfig },
                    },
                    [_vm._v("Merge Config ")]
                  ),
              !!_vm.value.boostConfig
                ? _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", color: "success" },
                      on: { click: _vm.onBoostConfig },
                    },
                    [_vm._v("Boost Config ")]
                  )
                : _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", outlined: "", color: "primary" },
                      on: { click: _vm.onBoostConfig },
                    },
                    [_vm._v("Boost Config ")]
                  ),
              !!_vm.value.upgradeConfig
                ? _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", color: "success" },
                      on: { click: _vm.onUpgradeConfig },
                    },
                    [_vm._v("Upgrade Config ")]
                  )
                : _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", outlined: "", color: "primary" },
                      on: { click: _vm.onUpgradeConfig },
                    },
                    [_vm._v("Upgrade Config ")]
                  ),
              !!_vm.value.recycleConfig
                ? _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", color: "success" },
                      on: { click: _vm.onRecycleConfig },
                    },
                    [_vm._v("Recycle Config ")]
                  )
                : _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", outlined: "", color: "primary" },
                      on: { click: _vm.onRecycleConfig },
                    },
                    [_vm._v("Recycle Config ")]
                  ),
              !!_vm.value.deprecateConfig
                ? _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", color: "success" },
                      on: { click: _vm.onDeprecateConfig },
                    },
                    [_vm._v("Deprecate Config ")]
                  )
                : _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", outlined: "", color: "primary" },
                      on: { click: _vm.onDeprecateConfig },
                    },
                    [_vm._v("Deprecate Config ")]
                  ),
              !!_vm.value.guardConfig
                ? _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", color: "success" },
                      on: { click: _vm.onGuardConfig },
                    },
                    [_vm._v("Guard Config ")]
                  )
                : _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", outlined: "", color: "primary" },
                      on: { click: _vm.onGuardConfig },
                    },
                    [_vm._v("Guard Config ")]
                  ),
              !!_vm.value.offerConfig
                ? _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", color: "success" },
                      on: { click: _vm.onOfferConfig },
                    },
                    [_vm._v("Offer Config ")]
                  )
                : _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", outlined: "", color: "primary" },
                      on: { click: _vm.onOfferConfig },
                    },
                    [_vm._v("Offer Config ")]
                  ),
              !!_vm.value.traderConfig
                ? _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", color: "success" },
                      on: { click: _vm.onTraderConfig },
                    },
                    [_vm._v("Trader Config ")]
                  )
                : _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", outlined: "", color: "primary" },
                      on: { click: _vm.onTraderConfig },
                    },
                    [_vm._v("Trader Config ")]
                  ),
              !!_vm.value.dragonConfig
                ? _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", color: "success" },
                      on: { click: _vm.onDragonConfig },
                    },
                    [_vm._v("Dragon Config ")]
                  )
                : _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", outlined: "", color: "primary" },
                      on: { click: _vm.onDragonConfig },
                    },
                    [_vm._v("Dragon Config ")]
                  ),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4", md: "4" } },
            [
              !!_vm.value.attributes
                ? _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", color: "success" },
                      on: { click: _vm.onAttributes },
                    },
                    [_vm._v("Attributes ")]
                  )
                : _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", outlined: "", color: "primary" },
                      on: { click: _vm.onAttributes },
                    },
                    [_vm._v(" Attributes ")]
                  ),
              !!_vm.value.infoConfig
                ? _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", color: "success" },
                      on: { click: _vm.onInfoConfig },
                    },
                    [_vm._v("Info Config ")]
                  )
                : _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", outlined: "", color: "primary" },
                      on: { click: _vm.onInfoConfig },
                    },
                    [_vm._v("Info Config ")]
                  ),
              !!_vm.value.touchConfig
                ? _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", color: "success" },
                      on: { click: _vm.onTouchConfig },
                    },
                    [_vm._v("Touch Config ")]
                  )
                : _c(
                    "v-btn",
                    {
                      staticClass: "my-1 fill-width",
                      attrs: { small: "", outlined: "", color: "primary" },
                      on: { click: _vm.onTouchConfig },
                    },
                    [_vm._v("Touch Config ")]
                  ),
              _c("v-checkbox", {
                staticClass: "mx-1 mt-0",
                attrs: { label: "Move", "hide-details": "" },
                model: {
                  value: _vm.value.move,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "move", $$v)
                  },
                  expression: "value.move",
                },
              }),
              _c("v-checkbox", {
                staticClass: "mx-1 mt-2",
                attrs: { label: "Swap", "hide-details": "" },
                model: {
                  value: _vm.value.swap,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "swap", $$v)
                  },
                  expression: "value.swap",
                },
              }),
              _c("v-checkbox", {
                staticClass: "mx-1 mt-2",
                attrs: { label: "Archive", "hide-details": "" },
                model: {
                  value: _vm.value.archive,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "archive", $$v)
                  },
                  expression: "value.archive",
                },
              }),
              _c("v-checkbox", {
                staticClass: "mx-1 mt-2",
                attrs: { label: "Delete", "hide-details": "" },
                model: {
                  value: _vm.value.delete,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "delete", $$v)
                  },
                  expression: "value.delete",
                },
              }),
              _c("v-checkbox", {
                staticClass: "mx-1 mt-2",
                attrs: { label: "Explode", "hide-details": "" },
                model: {
                  value: _vm.value.explode,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "explode", $$v)
                  },
                  expression: "value.explode",
                },
              }),
              _c("v-checkbox", {
                staticClass: "mx-1 mt-2",
                attrs: { label: "AutoReward", "hide-details": "" },
                model: {
                  value: _vm.value.autoreward,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "autoreward", $$v)
                  },
                  expression: "value.autoreward",
                },
              }),
              _c("v-checkbox", {
                staticClass: "mx-1 mt-2",
                attrs: { label: "Road Through", "hide-details": "" },
                model: {
                  value: _vm.value.roadThrough,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "roadThrough", $$v)
                  },
                  expression: "value.roadThrough",
                },
              }),
              _c("v-checkbox", {
                staticClass: "mx-1 mt-2",
                attrs: { label: "Info Enabled", "hide-details": "" },
                model: {
                  value: _vm.value.infoEnabled,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "infoEnabled", $$v)
                  },
                  expression: "value.infoEnabled",
                },
              }),
              _c("v-checkbox", {
                staticClass: "mx-1 mt-2",
                attrs: { label: "Bubble Reward", "hide-details": "" },
                model: {
                  value: _vm.value.bubbleReward,
                  callback: function ($$v) {
                    _vm.$set(_vm.value, "bubbleReward", $$v)
                  },
                  expression: "value.bubbleReward",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("r-search-config", { ref: "r-search-config" }),
      _c("r-worker-config", { ref: "r-worker-config" }),
      _c("r-guard-dialog", { ref: "r-guard-dialog" }),
      _c("r-reward-dialog", { ref: "v-reward-config" }),
      _c("r-attributes-dialog", { ref: "r-attributes-dialog" }),
      _c("r-item-info-config", { ref: "r-info-config" }),
      _c("r-item-boost-config", { ref: "r-boost-config" }),
      _c("r-item-merge-config", { ref: "r-merge-config" }),
      _c("r-item-offer-config", { ref: "r-offer-config" }),
      _c("r-item-trader-config", { ref: "r-trader-config" }),
      _c("r-item-dragon-config", { ref: "r-dragon-config" }),
      _c("r-item-upgrade-config", { ref: "r-upgrade-config" }),
      _c("r-item-recycle-config", { ref: "r-recycle-config" }),
      _c("r-item-deprecate-config", { ref: "r-deprecate-config" }),
      _c("r-item-touch-config", { ref: "r-touch-config" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }